import { render, staticRenderFns } from "./deveUnit.vue?vue&type=template&id=1f04373a&scoped=true&"
import script from "./deveUnit.vue?vue&type=script&lang=js&"
export * from "./deveUnit.vue?vue&type=script&lang=js&"
import style0 from "./deveUnit.vue?vue&type=style&index=0&id=1f04373a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04373a",
  null
  
)

export default component.exports